export const POWERSETTER_FUNNEL_ID = 'powersetter';
export const config = {
  id: 'powersetter',
  path: '/powersetter-dataentry',
  show: () => true,
};
